import { useRef } from "react";
import { ChatListItem } from "./ChatListItem";
import { useChatStore } from "../../stores/ChatStore";
import { useVirtualizer } from "@tanstack/react-virtual";
import { ChatGroupListItem } from "./ChatGroupListItem";

const ChatGroupListSearch = () => {
  const { listFilterChatGroup } = useChatStore();
  const parentRef = useRef<HTMLDivElement>(null);
  const listData = Object.keys(listFilterChatGroup)

  const virtualizer = useVirtualizer({
    count: listData.length,
    getScrollElement: () => parentRef.current,
    estimateSize: (index) => 300,
    overscan: 5, // Tambahkan elemen buffer di atas dan bawah
    enabled: true,
  });

  const splitKey = (key: string) => {
    const parts = key.split("-");
    const [p0, p1, p2, p3, ...rest] = parts;

    // default values
    let id = "";
    let phone = "";
    let type = "";
    let idChat = "";

    if (parts.length >= 5) {
      id = `${p0}-${p1}`;
      phone = p2;
      type = p3;
      idChat = rest.join("-");
    } else if (parts.length === 4) {
      id = `${p0}-${p1}`;
      phone = p2;
      type = p3;
    } else if (parts.length === 3) {
      id = p0;
      phone = p1;
      type = p2;
    }

    return { id, phone, type, idChat };
  };

  const items = virtualizer.getVirtualItems();

  return (
    <>
      <div
        ref={parentRef}
        style={{
          height: "100%",
          overflowY: "auto",
          position: "relative",
          contain: 'strict',
        }}
      >
        <div
          style={{
            height: virtualizer.getTotalSize(),
            position: "relative",
            width: '100%',
          }}
        >
          {items.map((virtualItem) => {
            const key = listData[virtualItem.index];
            const chatItem = listFilterChatGroup[key]
            const { id, phone, type, idChat } = splitKey(key);
            const parts = key.split("|");

            return (
              <div
                key={virtualItem.key.toString()}
                data-index={virtualItem.index}
                ref={virtualizer.measureElement}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  transform: `translateY(${virtualItem.start}px)`,
                }}
              >
                {
                  chatItem.chat.id &&
                  <ChatGroupListItem keyChatRoom={`${parts[0]}|${parts[1]}`} type={parts[2]} idChat={parts.slice(3).join("|")} />
                }
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export { ChatGroupListSearch };
